var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningDotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6602_9413)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.583496 6.99998C0.583496 3.45615 3.45634 0.583313 7.00016 0.583313C10.544 0.583313 13.4168 3.45615 13.4168 6.99998C13.4168 10.5438 10.544 13.4166 7.00016 13.4166C3.45634 13.4166 0.583496 10.5438 0.583496 6.99998Z",
    fill: "#DC180C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66699 6.99996C4.66699 5.71129 5.71166 4.66663 7.00033 4.66663C8.28899 4.66663 9.33366 5.71129 9.33366 6.99996C9.33366 8.28862 8.28899 9.33329 7.00033 9.33329C5.71166 9.33329 4.66699 8.28862 4.66699 6.99996Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6602_9413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningDotIcon);
export default __webpack_public_path__ + "static/media/warning-dot-icon.09a8870fdc67ab720bc6c79e14ddaae1.svg";
export { ForwardRef as ReactComponent };